module.exports = __webpack_public_path__ + "static/media/scheduler_text_coupon.97bf7269.xlsx";